import Audio from './Audio'

export default Audio
